import { render, staticRenderFns } from "./chongdie.vue?vue&type=template&id=c9cf4aa4&scoped=true&"
import script from "./chongdie.vue?vue&type=script&lang=js&"
export * from "./chongdie.vue?vue&type=script&lang=js&"
import style0 from "./chongdie.vue?vue&type=style&index=0&id=c9cf4aa4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9cf4aa4",
  null
  
)

export default component.exports